export default __webpack_public_path__ + "static/img54h-4c1f7b0ad9d19c55d168c3c829fbf043.jpg";